import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './redux/store';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ColorModeContext, useMode } from './theme.js';
import { LicenseInfo } from '@mui/x-license'; 

const LICENSE_KEY = process.env.REACT_APP_MUIX_LICENSE_KEY || 'YOUR_LICENSE_KEY';
LicenseInfo.setLicenseKey(LICENSE_KEY);

function Root() {
  const [theme, colorMode] = useMode();
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
